import { createContext } from 'react';

const SectionContext = createContext({
    justify: "left",
});

export { SectionContext };
